// Records HOW a shopper reached the order flow, on their cart.
//
// Extracted from AccessCodeOnlyForm so it can be unit-tested without React --
// the same reason stampLinkAttribution lives in a plain function, and the same
// reason it needs testing: it crashed the highest-traffic entry form.
//
// THE CART IS NOT ALWAYS A MODEL. `CustomerContext#rehydrate` restores the
// customer from localStorage with the line that would rebuild the Cart model
// commented out (its own FIXME: "passing cart to constructor throws error"),
// and the G1 self-heal only replaces a cart that is DEAD -- a live restored one
// keeps its plain-object shape for the life of the page. So any returning
// visitor with a cart carries one that has attributes but no methods.
//
// Calling `isDirty()` on that threw `customer.cart.isDirty is not a function`
// and took the Continue button down with it, which is the whole reason this
// exists. `stampLinkAttribution` already guards the same trap with
// `!cart.save`; this is that guard, applied to the sibling call site that did
// not have it.
//
// Skipping the save when the cart is a plain object is the ACCEPTED handling,
// not a new silent loss: stampLinkAttribution has returned false in exactly
// that case since it was written. The alternative -- rebuilding a Cart model
// here to PATCH with -- means guessing at spraypaint's persisted-vs-new
// semantics inside a live purchase path, which is a worse trade than losing an
// entry-method stamp on a page reload.
export function stampEntryMethod(cart, { createdLocation } = {}) {
  if (!cart) return false;

  if (createdLocation) cart.createdLocation = createdLocation;
  cart.entryMethod = 'typed_code';

  // Only PATCH when something actually changed: this is the highest-traffic
  // entry form, and a resubmit or a typo must not re-save an unchanged cart.
  if (typeof cart.isDirty !== 'function' || typeof cart.save !== 'function') return false;
  if (!cart.isDirty()) return false;

  cart.save();
  return true;
}

export default stampEntryMethod;
